/* eslint-disable no-multi-str */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import Input from './common/Input';
import { Badge, Form } from 'react-bootstrap';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";


const AddEvent = (props) => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [content, setContent] = useState('Enter Page Content...');


    const navigate = useNavigate();

    const redirect = () => {
        if (coreContext.isRequestComplete) navigate('/events');
    }

    useEffect(redirect, [coreContext.isRequestComplete]);

    const { register, handleSubmit, formState: { errors } } = useForm();


    const handleEditorChange = (content, editor) => {
        setContent(content);
    }

    const onEventContentHandler = (data) => {
        const { title, message, content, edate, etime } = data;
        coreContext.addEventContent(title, message, content, edate, etime, authContext.itemId, authContext.userId);
    }

    const check = () => {
        coreContext.check();
        navigate('/events');
    }

    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Add New Event</Badge></h3>
                {/* <button onClick={check}>Check</button> */}
            </div>
            <div className="card-body">
                <Form autoComplete='off' onSubmit={handleSubmit(onEventContentHandler)} noValidate>
                    <Input label='Title' name='title' minLength={2} maxLength={155} required={true} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' />

                    <Input label='Message' name='message' minLength={2} maxLength={2000} required={true} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' />

                    <div className="row"><div className="col-md-6">
                        <Input label='Event Date' name='edate' minLength={2} maxLength={50} required={true} register={register} errors={errors} elementType='date' placeholder='Enter Event Date' />
                    </div>
                        <div className="col-md-6">
                            <Input label='Event Time' name='etime' minLength={2} maxLength={50} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Event Time : 11am to 6pm' />
                        </div></div>

                    <Form.Group>
                        <Editor
                            apiKey={coreContext.key}
                            value={content}
                            init={{
                                height: 500,
                                menubar: 'insert',
                                file_picker_types: 'file image media',
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                ],
                                toolbar:
                                    'undo redo | formatselect | bold italic backcolor forecolor  | fontsize fontfamily lineheight  | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent image | removeformat | code | help'
                            }}
                            onEditorChange={handleEditorChange}
                        />
                    </Form.Group>
                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()}
                    <Input variant='danger' label={coreContext.message} elementType='label' />
                </Form>
            </div>
        </div>
    </div>
    )
}

export { AddEvent }